export default __webpack_public_path__ + "static/media/pencil-alt-filled-bold.ff1f9384.svg";